import Errors from '@shared/errors';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const initialState = () => {
  return {
    refereeStatus: '',
    seasons: [],
    venues: [],
    roster: [],
    availability: [],
    refereeErrors: new Errors(),
  }
}

const state = {
   initialState: initialState,
   ...initialState(),
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
